export const AarStorageExcelHeader = [
  {
    header: "PN",
    key: "pn",
  },
  {
    header: "SN",
    key: "sn",
  },
  {
    header: "PN DESCRIPTION",
    key: "pnDesc",
  },
  {
    header: "STORAGE",
    key: "storage",
  },
  {
    header: "CONDITION",
    key: "condition",
  },
  {
    header: "NOTE",
    key: "note",
  },
  {
    header: "REF NUMBER",
    key: "refNumber",
  },
  {
    header: "CREATED BY",
    key: "createdBy",
  },
  {
    header: "CREATED DATE",
    key: "createdDate",
  },
];
export const UpdateHistoryExcelColumns = [
  {
    header: "PN",
    key: "pn",
  },
  {
    header: "SN",
    key: "sn",
  },
  {
    header: "PN DESCRIPTION",
    key: "pnDesc",
  },
  {
    header: "STORAGE",
    key: "storage",
  },
  {
    header: "CONDITION",
    key: "condition",
  },
  {
    header: "NOTE",
    key: "note",
  },
  {
    header: "REF NUMBER",
    key: "refNumber",
  },
  {
    header: "Updated BY",
    key: "createdBy",
  },
  {
    header: "Update DATE",
    key: "createdDate",
  },
];
export const AarStorageExcelName = "AAR Storage List";
export const UpdateHistoryExcelName = "AAR Storage Update History";
